import {
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  Flex,
  Text,
  Box,
  Progress,
} from "@chakra-ui/react";

const StatProgress = ({
  label,
  value,
  number,
  helpNumber,
  helpText,
  helpColor,
  ml,
  h,
}: {
  label: string;
  value: number;
  number: number;
  helpNumber: number;
  helpText: string;
  helpColor: string;
  ml?: string;
  h?: string;
}) => {
  return (
    <Stat flex="1" ml={ml} variant="widget">
      <StatLabel fontSize="20px">{label}</StatLabel>
      <Flex w="100%" mt="30px" alignItems="top" h={h}>
        <Box flex="1">
          <Progress
            height="10px"
            value={value}
            borderRadius="15px"
            variant="stat"
            mb="10px"
          />
          <StatHelpText>
            <Text
              display="inline"
              color={helpColor}
              fontWeight="500"
              fontSize="17px"
            >
              {helpNumber}
            </Text>{" "}
            {helpText}
          </StatHelpText>
        </Box>
        <StatNumber ml="40px" mr="14px" fontSize="30px">
          {number}
        </StatNumber>
      </Flex>
    </Stat>
  );
};

export default StatProgress;
